var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8762 6.09743C14.2287 5.74487 14.8003 5.74487 15.1529 6.09743C15.4783 6.42286 15.5034 6.93495 15.228 7.2891L15.1529 7.37415L8.9463 13.5807C8.62087 13.9062 8.10878 13.9312 7.75463 13.6558L7.66958 13.5807L4.8484 10.7596C4.49585 10.407 4.49585 9.8354 4.8484 9.48284C5.17384 9.15741 5.68592 9.13237 6.04007 9.40774L6.12512 9.48284L8.30794 11.665L13.8762 6.09743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBlueIcon);
export default __webpack_public_path__ + "static/media/selected-blue-icon.b1e488f8bbe0f22941f24d056a5653b7.svg";
export { ForwardRef as ReactComponent };